<template>
	<div id="agentDetail">
		<DetailCardCPD :config="config"></DetailCardCPD>
		<IpMc :config='impconfig'></IpMc>
		<div id="adteq" v-loading='loading' class='gcardfr'>

			<el-row :gutter="20" class=''>
				<el-col :span='6'>
					<div class="glineflex">
						<label class="glinelb">SN：</label>
						<el-input v-model="ssn" size="mini" @keyup.enter.native="search"></el-input>
					</div>
				</el-col>
				<el-col :span='6'>
					<div class="glineflex">
						<label class="glinelb">{{ $t('app_status') }}：</label>
						<el-select size="small" v-model="est" clearable style="width: 100%;" :placeholder="$t('app_select')"
							@change="search">
							<el-option v-for="(item,index) in $ugUpdateSts" :key="index" :label="item.lb"
								:value="item.vl"></el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :span='6'>
					<div class="glineflex">
						<label class="glinelb">{{ $t('terminal.push_stauts') }}：</label>
						<el-select size="small" v-model="pst" clearable style="width: 100%;" :placeholder="$t('app_select')"
							@change="search">
							<el-option v-for="(item,index) in $pushtypes" :key="index" :label="item.lb"
								:value="item.vl"></el-option>
						</el-select>
					</div>
				</el-col>
			</el-row>
			<br />
			<el-row :gutter="20" class=''>
				<!-- v-if='!detail.parent && !$isNmAdminType()' -->
				<el-col :span='8'>
					<el-button size='small' @click='showBind' type="primary" icon="">{{ $t('terminal.binding_device') }}</el-button>
					<el-button size='small' type="" iicon="" @click='addMul'>{{ $t('app_batch_import') }}</el-button>
					<el-button size='small' type="" iicon="" @click='exportSt'>{{ $t('terminal.export_config') }}</el-button>
					<!-- <el-button  size='small' @click="batchImport" type='' plain>批量导入</el-button> 
            <el-button @click='batchDel' :disabled="sRows.length == 0" size='small' type='danger' plain>删除已选</el-button>  -->
				</el-col>
			</el-row>

			<el-table ref="multipleTable" class='gtbtop g-tb-pointer' tooltip-effect="dark" :data="tableData"
				@selection-change="batchSelected" style="width: 100%">
				<!-- <el-table-column
            type="selection"
            width="55">
          </el-table-column> -->
				<el-table-column prop="deviceId" :label="$t('terminal.device_sn')" width="">
				</el-table-column>
				<el-table-column prop="deviceStatus" :formatter="setSt" :label="$t('app_status')" width="150">
				</el-table-column>
				<el-table-column prop="deviceStatus" :formatter="setPst" :label="$t('terminal.push_stauts')" width="150">
				</el-table-column>
				<el-table-column prop="createTime" :label="$t('app_createTime')" width="176">
				</el-table-column>
				<el-table-column prop="completeTime" :label="$t('terminal.update_config_time')" width="176">
				</el-table-column>
				<el-table-column prop="name" :label="$t('app_operation')" width="120">
					<template slot-scope="scope">
						<span v-if='!detail.parent'>
							<!-- <el-button @click='moveRow(scope.row)' type='text' >移动</el-button>
                <label class='opbline'>|</label> -->
							<el-button @click='delRow(scope.row)' type='text' class='opdcolor'>{{ $t('app_unbind') }}</el-button>
						</span>
					</template>
				</el-table-column>
			</el-table>

			<Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>

		</div>

		<el-dialog @close="closeDiaBind" style="min-width: 1140px;" class="gstdia" :title="$t('terminal.binding_device')"
			:visible.sync="showBindDia">
			<el-row>
				<el-col :span="10">
					<el-input v-model="queryWords" placeholder="SN" @click="getDv" @keyup.enter.native="getDv">
					</el-input>
				</el-col>
			</el-row>
			<el-table v-loading="loading" ref="multipleTable" class='gtbtop g-tb-pointer' tooltip-effect="dark"
				:data="tableData1" @selection-change="batchSelected" style="width: 100%">
				<!-- <el-table-column
            type="selection"
            width="55">
          </el-table-column> -->
				<el-table-column prop="deviceid" :label="$t('terminal.device_sn')" width="">
				</el-table-column>
				<el-table-column prop="devicename" :label="$t('terminal.device_name')" width="">
				</el-table-column>
				<el-table-column prop="agentName" :label="$t('terminal.app_distributor')" width="">
				</el-table-column>
				<el-table-column prop="name" :label="$t('app_operation')" width="120">
					<template slot-scope="scope">
						<span v-if='!detail.parent'>
							<el-button @click='bindRow(scope.row.deviceid, "0")' type='text' class=''>{{ $t('app_bind') }}</el-button>
						</span>
					</template>
				</el-table-column>
			</el-table>
			<Pages class='gpages' :cpage='page1' :ctotal="total1" :config='pconfig1'></Pages>
		</el-dialog>
	</div>
</template>

<style>

</style>


<script>
	import DetailCardCPD from '@/components/DetailCardCPD.vue'
	import Pages from '@/components/Pages.vue'
	import IpMc from "@/components/ImportPm.vue";
	export default {
		data() {
			return {
				detail: {},
				pst: '',
				est: '',
				ssn: '',
				showBindDia: false,
				queryWords: '',
				queryLock: false,
				impconfig: {},
				showdia: false,
				pconfig: '',
				config: '',
				loading: false,
				pconfig1: '',
				tableData: [],
				tableData1: [],
				eqs: [],
				sRows: [],
				total: 0,
				total1: 0,
				page: 1,
				page1: 1,
				rules: {
					agentID: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}]
				},
			}
		},
		components: {
			DetailCardCPD,
			Pages,
			IpMc
		},
		methods: {
			exportSt() {
				this.$outputSetting(this.detail.id, this.est, this.pst)
			},
			search() {
				this.page = 1
				this.getList()
			},
			ImportMc() {
				var _this = this;
				this.impconfig = {
					pid: this.detail.id,
					showDia: true,
					callback: data => {
						_this.getList();
					}
				};
			},
			addMul() {
				this.ImportMc()
			},
			unbindRow(id) {
				this.loading = true
				this.$confUeq(id, res => {
					this.loading = false
					this.$message(res.message)
					if (res.status == 200) {
						this.getList()
					}
				}, () => {
					this.loading = false
				})
			},
			bindRow(did, type) {
				this.loading = true
				this.$confBeq(this.detail.id, did, type, res => {
					this.loading = false
					this.$message(res.message)
					if (res.status == 200) {
						this.getList()
						this.closeDiaBind()
					}
				}, () => {
					this.loading = false
				})
			},
			showBind() {
				this.showBindDia = true
				var _this = this
				this.pconfig1 = {
					callback: page => {
						_this.page1 = page
						_this.getDv()
					}
				}
				this.getDv()
			},
			closeDiaBind() {
				this.showBindDia = false;
				this.queryWords = ''
			},
			setSt(row) {
				var sts = {
					'0': this.$t('app_not_update'),
					'1':  this.$t('app_update')
				}
				return sts[row.status + '']
			},
			setPst(row) {
				var sts = {
					'0': this.$t('app_notpushed'),
					'1': this.$t('app_message_pushed')
				}
				return sts[row.lssueStatus + '']
			},
			rqsBefore() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.okDia()
					}
				})
			},
			okDia() {
				this.$editAgent(this.tform.agentID, this.tform.clientKey, this.tform.agentName, this.tform.agentPeople,
					this.tform.phone, this.tform.parentId, res => {
						if (res.status == 200) {
							this.closeDia()
							// this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}

					}, '')
			},
			delRqs(did) {
				this.$agentUnbindEq(this.agId, did, res => {
					if (res.status == 200) {
						this.getList()
						this.$message.success(res.message)
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			delRow(row) {
				// console.log(row)  row.deviceid
				this.$showMsgBox(this.$t('app_sure_unbind'), () => {
					this.unbindRow(row.id)
				})
			},
			batchDel() {
				this.$showMsgBox(this.$t('app_sure_unbind_2'), () => {
					var ar = []
					this.sRows.forEach(item => {
						ar.push(item.deviceid)
					})
					this.delRqs(ar.toString())
				})
			},
			batchSelected(val) {
				this.sRows = val
			},
			getDv() {
				this.loading = true
				var deviceId = this.queryWords ? this.queryWords : ''
				this.$terList(this.page1, this.$gRow, deviceId, '','','', '', '', '', '', '', '', '', '1','1', res => {
					this.loading = false
					if (res.status == 200) {
						this.tableData1 = res.data
						this.total1 = res.total
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})
			},
			getList() {
				this.$confEQlist(this.detail.id, this.page, this.$gRow, this.est, this.pst, this.ssn, res => {
					if (res.status == 200) {
						this.tableData = res.data
						this.total = res.total
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			setCard(data) {
				this.config = {
					rd1: {
						tt: this.$t('terminal.risk_name'),
						ct: this.detail.name
					},
					rd2: {
						tt: this.$t('terminal.risk_content'),
						ct: this.detail.content
					},
				}
			}
		},
		mounted() {
			this.detail = this.$getTmp('param')
			this.setCard()
			this.getList()
			var _this = this
			this.pconfig = {
				callback: page => {
					///
					_this.page = page
					_this.getList()
				}
			}


		}
	}
</script>
